export default __webpack_public_path__ + "static/media/nofile.a5eb132f.png";